import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import DownloadCounter from '../DownloadCounter';
import { SectionHeader, CardHeader } from './CabinetHeader';
import './DashboardContent.css';

const DashboardContent = () => {
  const { t } = useTranslation();
  const [showOldVersions, setShowOldVersions] = useState(false);
  const [downloadHistory] = useState([
    { id: 1, date: '2024-01-15', version: 'v2.1', size: '245 KB' },
    { id: 2, date: '2024-01-10', version: 'v2.0', size: '240 KB' },
    { id: 3, date: '2024-01-05', version: 'v1.9', size: '238 KB' },
  ]);

  const handleDownload = () => {
    alert('Download will be available soon!');
  };

  const filteredHistory = showOldVersions 
    ? downloadHistory 
    : downloadHistory.slice(0, 1);

  return (
    <div className="dashboard-content-v3">
      <div className="dashboard-grid-v3">
        <div className="dashboard-left-v3">
          <div className="dashboard-card-v3 stats-card-v3">
            <CardHeader title={t('cabinet.downloadStats')} />
            <DownloadCounter variant="default" />
          </div>

          <div className="dashboard-card-v3 download-card-v3">
            <CardHeader title={t('cabinet.downloadButton')} />
            <button className="download-btn-dashboard" onClick={handleDownload}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                <polyline points="7 10 12 15 17 10" />
                <line x1="12" y1="15" x2="12" y2="3" />
              </svg>
              <span>{t('cabinet.downloadButton')}</span>
            </button>
            <p className="download-hint-dashboard">{t('cabinet.downloadHint')}</p>
          </div>

          <div className="dashboard-card-v3 security-card-v3">
            <CardHeader title={t('cabinet.securityCheck')} />
            <div className="security-status-dashboard">
              <div className="security-icon-dashboard">✅</div>
              <div className="security-info-dashboard">
                <div className="security-text-dashboard">{t('cabinet.virusTotal.desc')}</div>
                <div className="security-badge-dashboard">{t('common.safe')}</div>
              </div>
            </div>
          </div>
        </div>
        <div className="dashboard-right-v3">
          <div className="dashboard-card-v3 description-card-v3">
            <CardHeader title={t('cabinet.aboutFile')} />
            <p className="description-text-dashboard" dangerouslySetInnerHTML={{ __html: t('cabinet.fileDescription') }} />
            <div className="features-list-dashboard">
              <div className="feature-item-dashboard">
                <span className="feature-check-dashboard">✓</span>
                <span>{t('cabinet.fileFeatures.ips')}</span>
              </div>
              <div className="feature-item-dashboard">
                <span className="feature-check-dashboard">✓</span>
                <span>{t('cabinet.fileFeatures.updates')}</span>
              </div>
              <div className="feature-item-dashboard">
                <span className="feature-check-dashboard">✓</span>
                <span>{t('cabinet.fileFeatures.compatible')}</span>
              </div>
              <div className="feature-item-dashboard">
                <span className="feature-check-dashboard">✓</span>
                <span>{t('cabinet.fileFeatures.easy')}</span>
              </div>
            </div>
          </div>

          <div className="dashboard-card-v3 history-card-v3">
            <SectionHeader 
              title={t('cabinet.downloadHistory')}
              action={
                <button 
                  className="toggle-btn-dashboard"
                  onClick={() => setShowOldVersions(!showOldVersions)}
                >
                  {showOldVersions ? t('cabinet.hideOldVersions') : t('cabinet.showOldVersions')}
                </button>
              }
            />
            <div className="history-list-dashboard">
              {filteredHistory.map((item) => (
                <div key={item.id} className="history-item-dashboard">
                  <div className="history-info-dashboard">
                    <span className="history-version-dashboard">{item.version}</span>
                    <span className="history-date-dashboard">{item.date}</span>
                    <span className="history-size-dashboard">{item.size}</span>
                  </div>
                  <button className="history-download-btn-dashboard" onClick={handleDownload}>
                    {t('common.download')}
                  </button>
                </div>
              ))}
            </div>
          </div>

          <div className="dashboard-card-v3 info-card-dashboard">
            <div className="info-grid-dashboard">
              <div className="info-item-dashboard">
                <div className="info-icon-dashboard">📋</div>
                <div className="info-content-dashboard">
                  <h4>{t('cabinet.infoCards.format.title')}</h4>
                  <p>{t('cabinet.infoCards.format.desc')}</p>
                </div>
              </div>
              <div className="info-item-dashboard">
                <div className="info-icon-dashboard">🔄</div>
                <div className="info-content-dashboard">
                  <h4>{t('cabinet.infoCards.updates.title')}</h4>
                  <p>{t('cabinet.infoCards.updates.desc')}</p>
                </div>
              </div>
              <div className="info-item-dashboard">
                <div className="info-icon-dashboard">💡</div>
                <div className="info-content-dashboard">
                  <h4>{t('cabinet.infoCards.howToUse.title')}</h4>
                  <p>{t('cabinet.infoCards.howToUse.desc')}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardContent;

